import 'bootstrap';
import React from 'react';
import getDoc from '../../qdoc';

class Kpi extends React.Component {
  constructor(props) {
    super(props);

    this.getObject = getDoc.then(doc => {
      return doc.createSessionObject({
        qInfo: {
          qType: "visualization"
        },
        value: {
          qStringExpression: this.props.expression
        }
      });
    });

    this.state = {
      value: []
    }
   }

  componentDidMount() {
    this.getLayout();
    this.getObject.then(object => {
      object.on('changed', () => {
        this.getLayout();
      });
    });
  }
  componentWillUnmount() {
    
  }

  getLayout() {
    this.getObject.then(object => {
      object.getLayout().then(layout => {
        this.setState({ value: layout.value});
      });
    });
  }

  render() {
    return (
      <div className="value">
        {this.state.value}
      </div>
    )
  }
}
export default Kpi;


// WEBPACK FOOTER //
// ./components/Kpis/Kpi.js